import { createApp, h } from 'vue'
import Loading from '@/components/h5/appLoading.vue'
// let loadingAppInstance = null

export default {
  install(app) {
    // 创建挂载点
    const loadingDiv = document.createElement('div')
    loadingDiv.style.width = '100%';
    loadingDiv.style.height = '100%';
    loadingDiv.id = 'loading-container'
    loadingDiv.style.display = 'none'
    document.body.appendChild(loadingDiv)
    const loadingRef = ref(null)
    // 创建独立的Vue应用来管理Loading组件
    const loadingApp = createApp({
      render: () => h(Loading, {ref: loadingRef})
    })
    
    // 挂载并保存实例
    loadingApp.mount('#loading-container')
    // console.log("load",loadingAppInstance)
    
    // 添加全局方法
    window.$appLoading = {
      show: function (options) {
        document.getElementById('loading-container').style.display = 'block'
       loadingRef.value?.tryShow(options)
      } ,
      hide: function () {
        document.getElementById('loading-container').style.display = 'none'
        loadingRef.value?.tryHide()     
       }
    }
  }
}